import ApiGenerator from '@services/ApiGenerator';

const GET = 'osba/accountLinks/GET';
const GET_ERROR = 'osba/accountLinks/GET_ERROR';
const GET_RECEIVED = 'osba/accountLinks/GET_RECEIVED';
const SAVE = 'osba/accountLinks/SAVE';
const SAVE_ERROR = 'osba/accountLinks/SAVE_ERROR';
const SAVE_RECEIVED = 'osba/accountLinks/SAVE_RECEIVED';

const initialState = {
  Links: [],
  loading: false,
  message: '',
  error: '',
};

const mapResponse = data => ({
  Links: data.Model.Links,
  message: data.Message,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SAVE:
      return {
        ...state,
        ...action.data,
        loading: true,
        error: '',
      };
    case GET_RECEIVED:
    case SAVE_RECEIVED:
      return {
        ...state,
        ...mapResponse(action.data),
        loading: false,
      };
    case GET_ERROR:
    case SAVE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const getLinksInfo = () => ({
  type: GET,
});

export const saveLinksInfo = data => ({
  type: SAVE,
  data: {
    Links: data.Links,
  },
});

export const middleware = () => next => (action) => {
  const api = ApiGenerator(next);

  next(action);

  switch (action.type) {
    case GET:
      api('get', '/Links/Get', GET);
      break;
    case SAVE:
      api('post', '/Links/Save', SAVE, {
        ...action.data,
      });
      break;
    default:
      break;
  }
};

export default reducer;
